import React, { useState, useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import { ToastContainer } from "react-toastify";
import { Button } from "primereact/button";
import {
  isValidEmail,
  isValidMobileNumber,
  isValidMobileNumberWithcode,
} from "../components/ValidationServices";
import APIService from "../components/postServices";
import { useLocation, useNavigate } from "react-router-dom";
import { Dialog } from "primereact/dialog";

import { Card } from "primereact/card";
import { showToast } from "../components/toastServices";
import PublicHeader from "../components/header";

// const classList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
// const sectionList = ["A", "B", "C", "D", "E", "I"];

const initialFormData = {
  studentNo: "",
  dob: "",
  mobile: "",
  email: "",
};
function VerificationForm() {
  const siteKey = process.env.REACT_APP_SITE_KEY;

  const navigate = useNavigate();
  const [PaymentFormData, setPaymentFormData] = useState(initialFormData);
  const [UserformError, setFormError] = React.useState({});

  const [error, setError] = React.useState(false);
  const [errors, setErrors] = useState({});

  const [loading, setLoading] = useState(false);
  const recaptchaRef = React.createRef();
  const [capValue, setCapValue] = useState(null);

  // ++++++++++++ payment related  ++++++++++++++++++++++

  const [paymentSuccess, setpaymentSuccess] = React.useState(false);
  const [success, setSuccess] = React.useState(false);

  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const status = params.get("status");
  const bank_ref_no = params.get("bank_ref_no");
  const amount = params.get("amount");
  const orderId = params.get("orderId");

  const tracking_id = params.get("tracking_id");

  useEffect(() => {
    if (status === "Success") {
      setpaymentSuccess(true);
      setSuccess(true);
    } else if (status === "Failure") {
      setpaymentSuccess(false);
      setSuccess(true);
    } else if (status === "Aborted") {
      setpaymentSuccess(false);
      setSuccess(true);
    } else if (status === "Completed") {
      setSuccess(false);
    } else {
      setSuccess(false);
    }
  }, [status]);

  // ++++++++++++ payment related  ++++++++++++++++++++++

  const PaymentFormDataChange = (event) => {
    const { name, value } = event.target;
    // Update the form state with the new value
    setPaymentFormData({
      ...PaymentFormData,
      [name]: value,
    });

    // Perform validation on the fly and update the errors state
    const newErrors = {
      ...errors,
      [name]:
        // name === "email"
        //   ? value !== "" && !isValidEmail(value)
        //   : !isValidMobileNumber(value),

        name === "email"
          ? value !== "" && !isValidEmail(value)
          : name === "mobile"
          ? value !== "" && !isValidMobileNumber(value)
          : "",
    };
    setErrors(newErrors);
  };

  const handleError = (error, input) => {
    setFormError((prevState) => ({ ...prevState, [input]: error }));
    setError(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let isValid = true;
    let studentNo = PaymentFormData.studentNo;
    let dob = PaymentFormData.dob;
    let mobile = PaymentFormData.mobile;
    let email = PaymentFormData.email;

    if (studentNo === "") {
      handleError("Please input Student Number", "studentNo");
      isValid = false;
    }

    if (dob === "") {
      handleError("Please select Date of birth", "dob");
      isValid = false;
    }
    if (!email) {
      handleError("Please input email address", "email");
      isValid = false;
    }
    if (!mobile) {
      handleError("Please input mobile number", "mobile");
      isValid = false;
    }

    // if (!capValue) {
    //   handleError("Please confirm you are human", "captcha");
    //   isValid = false;
    // }

    if (isValid) {
      setLoading(true);
      try {
        const response = await APIService.Post(
          `/User/AddNewQuickPaymentUsers`,
          PaymentFormData
        );

        if (response.responseCode === 1) {
          // setIsOtp(true);
          navigate("/Verify", {
            state: { data: response.dataSet },
            replace: true,
          });
          setLoading(false);
          // showToast("Sucess", "Please check your email for OTP");
        }
      } catch (error) {
        setLoading(false);
        console.error("Error:", error);
      }
      setLoading(false);
    }
  };

  const hideDialog = () => {
    setSuccess(false);
    // window.location.href = "https://stjudesonline.in/";
    // navigate("/", { replace: true });
    // history.push(location.pathname);
    window.location.replace("http://stjudesonline.in");
  };

  const header = (
    <>
      <i
        className={
          paymentSuccess === true ? "pi pi-check-circle" : "pi pi-times-circle"
        }
        style={{
          fontSize: "2.5rem",
          color: paymentSuccess === true ? "green" : "red",
        }}
      ></i>
    </>
  );
  const footer = (
    <div className="flex flex-wrap justify-content-end gap-2">
      <button
        label="Ok"
        size="small"
        className="btn btn-info btn-sm"
        onClick={hideDialog}
      >
        OK
      </button>
    </div>
  );

  const breadcrumb = [{ label: "Online Payment", url: "/" }];

  return (
    <div className="main-page">
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <Dialog
        // maximizable
        visible={success}
        style={{ width: "40vw", background: "#ff6358" }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Payment Result"
        modal
        className="p-fluid "
        onHide={hideDialog}
      >
        <br />
        <div className="row  justify-content-center">
          <div className=" flex text-center">
            <Card
              // title={paymentSuccess === true ? "Success" : "Failed"}
              title={
                status === "Success"
                  ? "Success"
                  : status === "Failure"
                  ? "Failed"
                  : status === "Aborted"
                  ? "Cancelled"
                  : ""
              }
              footer={footer}
              header={header}
              className="md:w-30rem"
              style={{ boxShadow: "none" }}
            >
              <h4 className="m-0">
                {paymentSuccess === true
                  ? "Payment completed successfully"
                  : "Transaction unsuccessful"}
              </h4>
              <p>
                {status === "Success"
                  ? "Thank you! You will soon receive notifications on WhatsApp and via email. For any further queries, please email us at sjps@stjudesonline.in or feel free to contact us directly at 04266 275709 / 04266 275809."
                  : status === "Failure"
                  ? "Apologies, but your transaction has not been approved. If you have any concerns or questions, please feel free to reach out us directly at 04266 275709 / 04266 275809 or please email us at sjps@stjudesonline.in"
                  : status === "Aborted"
                  ? "If you have any concerns or questions, please feel free to reach out us directly at 04266 275709 / 04266 275809 or please email us at sjps@stjudesonline.in"
                  : ""}
              </p>
              <p className="" style={{ fontSize: "medium" }}>
                {orderId && `Order Id : ${orderId}`}
              </p>
              <p className="" style={{ fontSize: "medium" }}>
                {tracking_id === 0 ? " " : `Transaction Id : ${tracking_id}`}
              </p>
              <p className="" style={{ fontSize: "medium" }}>
                {amount === 0 ? " " : `Amount : INR ${amount}`}
              </p>
            </Card>
          </div>
        </div>
      </Dialog>
      <PublicHeader breadcrumb={breadcrumb} title={"Online Payment"} />
      <div className="content-wrapper mt-10">
        <div className="col-md-12">
          <h3 className="text-center">
            Online Payment
            {/* <small>Make payment and submit the application form</small> */}
          </h3>

          <div className=" reg">
            {/* <div className="box-header text-center">
              <h3 className="box-title">Information</h3>
            </div> */}
            <div className="box-body">
              <div className="col-md-12 p-25">
                <>
                  <div className="">
                    <div className="form-group row">
                      <label className="col-md-4 col-form-label">
                        Student No{" "}
                        <i aria-hidden="true" className="ml-2 redColor">
                          {" "}
                          *{" "}
                        </i>{" "}
                      </label>
                      <div className="col-md-8">
                        <div className="input-group">
                          <input
                            type="text"
                            placeholder="Student Number"
                            className="form-control form-control-sm"
                            id="studentNo"
                            name="studentNo"
                            value={PaymentFormData.studentNo}
                            onChange={PaymentFormDataChange}
                            onFocus={() => handleError(null, "studentNo")}
                          />
                        </div>
                        {error && UserformError.studentNo && (
                          <span className="redColor">
                            {UserformError.studentNo}
                          </span>
                        )}
                      </div>
                    </div>

                    {/* <div className="form-group row">
                      <label className="col-md-4 col-form-label">
                        class{" "}
                        <i aria-hidden="true" className="ml-2 redColor">
                          {" "}
                          *{" "}
                        </i>{" "}
                      </label>
                      <div className="col-md-8">
                        <div className="input-group">
                          <select
                            onChange={PaymentFormDataChange}
                            className="k-dropdownlist form-control form-control-sm"
                            style={{ width: "300px" }}
                            placeholder="class"
                            id="class"
                            name="class"
                            value={PaymentFormData.class}
                            onFocus={() => handleError(null, "class")}
                          >
                            <option value=""> </option>
                            {classList.length !== 0
                              ? classList.map((item) => (
                                  <option key={item} value={item}>
                                    {item}
                                  </option>
                                ))
                              : ""}
                          </select>
                        </div>
                        {error && UserformError.class && (
                          <span className="redColor">
                            {UserformError.class}
                          </span>
                        )}
                      </div>
                    </div> */}

                    {/* <div className="form-group row">
                      <label className="col-md-4 col-form-label">
                        section{" "}
                        <i aria-hidden="true" className="ml-2 redColor">
                          {" "}
                          *{" "}
                        </i>{" "}
                      </label>
                      <div className="col-md-8">
                        <div className="input-group">
                          <select
                            onChange={PaymentFormDataChange}
                            className="k-dropdownlist form-control form-control-sm"
                            style={{ width: "300px" }}
                            placeholder="section"
                            id="section"
                            name="section"
                            value={PaymentFormData.section}
                            onFocus={() => handleError(null, "section")}
                          >
                            <option value=""> </option>
                            {sectionList.length !== 0
                              ? sectionList.map((item) => (
                                  <option key={item} value={item}>
                                    {item}
                                  </option>
                                ))
                              : ""}
                          </select>
                        </div>
                        {error && UserformError.section && (
                          <span className="redColor">
                            {UserformError.section}
                          </span>
                        )}
                      </div>
                    </div> */}

                    <div className="form-group row">
                      <label className="col-md-4 col-form-label">
                        Date of Birth{" "}
                        <i aria-hidden="true" className="ml-2 redColor">
                          {" "}
                          *{" "}
                        </i>{" "}
                      </label>
                      <div className="col-md-8">
                        <div className="input-group">
                          <input
                            type="date"
                            placeholder="dd-mm-yyyy"
                            format="dd-mm-yyyy"
                            className="form-control form-control-sm"
                            id="dob"
                            name="dob"
                            value={PaymentFormData.dob}
                            onChange={PaymentFormDataChange}
                            onFocus={() => handleError(null, "dob")}
                          />
                        </div>
                        {error && UserformError.dob && (
                          <span className="redColor">{UserformError.dob}</span>
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-md-4 col-form-label">
                        Mobile No{" "}
                        <i aria-hidden="true" className="ml-2 redColor">
                          {" "}
                          *{" "}
                        </i>{" "}
                      </label>
                      <div className="col-md-8">
                        <div className="input-group">
                          <input
                            type="text"
                            placeholder="Eg : 1234567890"
                            className="form-control form-control-sm"
                            id="mobile"
                            name="mobile"
                            value={PaymentFormData.mobile}
                            onChange={PaymentFormDataChange}
                            onFocus={() => handleError(null, "mobile")}
                          />
                        </div>
                        {errors.mobile && (
                          <div className="redColor">Invalid mobile number</div>
                        )}
                        {error && UserformError.mobile && (
                          <span className="redColor">
                            {UserformError.mobile}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-md-4 col-form-label">
                        Email{" "}
                        <i aria-hidden="true" className="ml-2 redColor">
                          {" "}
                          *{" "}
                        </i>{" "}
                      </label>
                      <div className="col-md-8">
                        <div className="input-group">
                          <input
                            type="text"
                            placeholder="Eg : example@mail.com"
                            className="form-control form-control-sm"
                            id="email"
                            name="email"
                            value={PaymentFormData.email}
                            onChange={PaymentFormDataChange}
                            onFocus={() => handleError(null, "email")}
                          />
                        </div>
                        {errors.email && (
                          <div className="redColor">Invalid email address</div>
                        )}
                        {error && UserformError.email && (
                          <span className="redColor">
                            {UserformError.email}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <br />
                  <>
                    <div className="form-group row">
                      <div className="col-md-6"></div>
                      <div className="col-md-6">
                        <div
                          className="form-group row pull-right"
                          style={{ justifyContent: "right" }}
                        >
                          <ReCAPTCHA
                            ref={recaptchaRef}
                            sitekey={siteKey}
                            // onChange={showResponse}
                            onChange={(val) => setCapValue(val)}
                            onFocus={() => handleError(null, "captcha")}
                          />
                          {error && UserformError.captcha && (
                            <span className="redColor">
                              {UserformError.captcha}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <br />
                    <div className="form-group row pull-right">
                      <div
                        className="col-md-12 button-container "
                        style={{ justifyContent: "center" }}
                      >
                        <Button
                          label="Submit"
                          // icon="pi pi-check"
                          loading={loading}
                          onClick={handleSubmit}
                          severity="danger"
                          size="large"
                          // disabled={!capValue}
                        />
                      </div>
                    </div>
                  </>
                </>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VerificationForm;
